export type ModalBackdropThemeValue = { backdropFilter: boolean };

export const modalBackdropTheme: ModalBackdropThemeValue = {
  backdropFilter: false,
};
